import { useParams, useNavigate } from 'react-router-dom';
import { useTopicPage } from '../hooks/useApi';

// Add custom styles for markdown content
const markdownStyles = {
  '.markdown-content hr': {
    margin: '1rem 0',  // Reduce margin from default to 1rem (16px) top and bottom
    height: '1px',     // Make hr thinner
    backgroundColor: '#e5e7eb', // Light gray color (gray-200)
    border: 'none'     // Remove default border
  }
};

function TopicPage() {
  const { topic } = useParams();
  const navigate = useNavigate();
  const { data: topicPage, isLoading, error } = useTopicPage(topic);

  if (isLoading) {
    return (
      <div className="animate-pulse p-6">
        <div className="h-8 bg-gray-200 rounded w-1/4 mb-6"></div>
        <div className="space-y-4">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="text-red-500">Error loading topic page: {error.message}</div>
      </div>
    );
  }

  if (!topicPage?.[0]) {
    return (
      <div className="p-6">
        <div className="text-red-500">Topic page not found</div>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
      </div>

      <div className="prose max-w-none markdown-content">
        <style>
          {`
            .markdown-content hr {
              margin: 1rem 0;
              height: 1px;
              background-color: #e5e7eb;
              border: none;
            }
          `}
        </style>
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{ __html: topicPage[0].content_html || topicPage[0].content }}
        />
      </div>
    </div>
  );
}

export default TopicPage;